export class Deferred<T> {
  constructor() {
    this._promise = new Promise<T>((resolve, reject) => {
      this._resolve = resolve
      this._reject = reject
    })
  }

  private _promise: Promise<T>
  private _resolve: ((result: T | PromiseLike<T>) => void) | null = null
  private _reject: ((error: Error) => void) | null = null

  public get promise(): Promise<T> {
    return this._promise
  }

  public resolve(result: T | PromiseLike<T>) {
    if (this._resolve) {
      this._resolve(result)
    } else {
      throw new Error('Unable to resolve promise')
    }
  }

  public reject(error: Error) {
    if (this._reject) {
      this._reject(error)
    } else {
      throw new Error('Unable to reject promise')
    }
  }
}
